import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alt", "bordered", "onError", "onLoad", "objectFit", "responsive", "shape", "src"];
import { forwardRef } from 'react';
import { throwErrorAsync } from '../../utils/throwError/throwError';
import { isUnsafeUrl } from '../../utils/unsafeUrl/unsafeUrl';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledImage = styled.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-1k0wx5v-0"
})(({
  $responsive,
  $shape,
  $objectFit,
  $bordered,
  $cssStyles,
  theme
}) => {
  return Object.assign({
    verticalAlign: 'middle',
    borderWidth: $bordered ? theme.borderWidth['100'] : undefined,
    borderStyle: $bordered ? 'solid' : undefined,
    borderColor: $bordered ? 'currentcolor' : undefined,
    borderRadius: $shape === 'circle' ? theme.borderRadius['full'] : $shape === 'rounded' || $shape === 'thumbnail' ? theme.borderRadius['100'] : undefined,
    display: $responsive ? 'block' : undefined,
    blockSize: $responsive ? 'auto' : undefined,
    maxInlineSize: $responsive ? '100%' : undefined,
    objectFit: $objectFit
  }, $cssStyles);
});
export const Image = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      alt = '',
      bordered = false,
      onError,
      onLoad,
      objectFit = 'fill',
      responsive = true,
      shape = 'default',
      src
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(restProps, {
    isImage: true
  });
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  if (isUnsafeUrl(src)) {
    throwErrorAsync(new Error(`Image: Detected XSS attempt! src="${src}"`));
  }
  const handleImageError = evt => {
    if (onError) onError(evt);
  };
  const handleImageLoad = evt => {
    if (onLoad) onLoad(evt);
  };
  return /*#__PURE__*/_jsx(StyledImage, Object.assign({
    alt: alt,
    onError: handleImageError,
    onLoad: handleImageLoad,
    ref: ref,
    src: isUnsafeUrl(src) ? undefined : src,
    $responsive: responsive,
    $shape: shape,
    $objectFit: objectFit,
    $bordered: bordered,
    $cssStyles: cssStyles
  }, domProps));
});
Image.displayName = 'Image';